import Login from '@/app/auth/login'

export default Login
